import { getUserAgent } from '@philips-internal/oswald-ui-utils';
function isKaiOS() {
    return /kaios/i.test(getUserAgent());
}
function isFirefox() {
    return /firefox/i.test(getUserAgent());
}
function isSafari() {
    return Object.prototype.hasOwnProperty.call(window, 'GestureEvent');
}
export { isKaiOS, isFirefox, isSafari, };
//# sourceMappingURL=text-to-speech-utils.js.map